<template>
	<div class="cookie-notice" v-if="visible">
		<div class="cookie-content">
			<h2 class="cookie-title">Tu privacidad importa</h2>
			<p class="cookie-text">
				Usamos cookies para mejorar tu experiencia, personalizar contenido y analizar nuestro tráfico. Al hacer clic en “Aceptar todas”
				<!--				<a href="/politica-de-cookies" target="_blank" rel="noopener noreferrer">Política de Cookies</a>.-->
			</p>
		</div>
		<div class="cookie-actions">
			<SecondaryButton class="cookie-button" @click="rejectCookies"> Rechazar todas</SecondaryButton>
			<AccentButton class="cookie-button" @click="acceptCookies"> Aceptar todas</AccentButton>
		</div>
	</div>
	<CustomModal v-if="showModal" title="¡Cuidado!" variant="centered">
		<div class="container">
			<p>Has rechazado las cookies. Algunas funciones de la aplicación pueden no funcionar correctamente sin ellas.</p>
		</div>
		<template #footer>
			<AccentButton class="w-100" @click="showModal = false"> Entendido</AccentButton>
		</template>
	</CustomModal>
</template>

<script>
import AccentButton from "@/components/ui/buttons/variants/AccentButton.vue";
import SecondaryButton from "@/components/ui/buttons/variants/SecondaryButton.vue";
import {cookieConsentBus, cookieManager} from "@/service/cookieManager";
import CustomModal from "@/components/ui/CustomModal.vue";

export default {
	name: "CookieNotice",
	components: {
		CustomModal,
		AccentButton,
		SecondaryButton,
	},
	data() {
		return {
			visible: false,
			showModal: false,
		};
	},
	methods: {
		acceptCookies() {
			cookieManager.setConsent(true);

			const token = localStorage.getItem("pending-token");
			if (token) {
				cookieManager.setToken(token);
				localStorage.removeItem("pending-token");
			}
			cookieConsentBus.dispatchEvent(
				new CustomEvent("consent-changed", {
					detail: true,
				})
			);
			this.visible = false;
		},

		rejectCookies() {
			cookieManager.setConsent(false);
			localStorage.removeItem("pending-token");
			cookieManager.clearToken();
			cookieConsentBus.dispatchEvent(
				new CustomEvent("consent-changed", {
					detail: false,
				})
			);
			this.visible = false;
			this.showModal = true;
		},
	},
	mounted() {
		this.acceptCookies()
		const noConsent = !cookieManager.hasConsent();
		this.visible = noConsent || !cookieManager.cookiesAvailable;
	},
};
</script>
